export class MaVessel {
  vessel_id: number | null ;
  imo_number: string | null ;
  name: string | null ;
  grt: number | null ;
  rgrt: number | null ;
  nrt: number | null ;
  loa: number | null ;
  beam: number | null ;
  depth: number | null ;
  type: number | null ;
  dwt: number | null ;
  displayFlag: string | null ;
  status: string | boolean | null ;
  email: string | null ;
  is_manual: string | null ;
  selected?: boolean;

  constructor(maVessel?: Partial<MaVessel>) {
    Object.assign(this, maVessel);
    this.vessel_id = maVessel?.vessel_id ?? null;
    this.imo_number = maVessel?.imo_number ?? null;
    this.name = maVessel?.name ?? null;
    this.grt = maVessel?.grt ?? null;
    this.rgrt = maVessel?.rgrt ?? null;
    this.nrt = maVessel?.nrt ?? null;
    this.loa = maVessel?.loa ?? null;
    this.beam = maVessel?.beam ?? null;
    this.depth = maVessel?.depth ?? null;
    this.type = maVessel?.type ?? null;
    this.dwt = maVessel?.dwt ?? null;
    this.displayFlag = maVessel?.displayFlag ?? null;
    this.status = true; //maVessel?.status ?? null;
    this.email = maVessel?.email ?? null;
    this.is_manual = maVessel?.is_manual ?? null;
  }
}

// Method to allowOnlyNumbers
export const allowOnlyNumbers = (event: KeyboardEvent) => {
  const regex = /^[0-9]$/;
  if (!regex.test(event.key)) {
    event.preventDefault();
  }
}
